import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Product } from '@libs/index';
import { BusinessObjectUtils } from '@libs/index';

@Component({
  selector: 'app-salon-card',
  templateUrl: './salon-card.component.html',
  styleUrls: ['./salon-card.component.scss'],
})
export class SalonCardComponent {
  public readonly NUMBER_OF_DISCOUNT_PRODUCT_TO_SHOW = 2;

  @Input() salonName: string;
  @Input() salonAddress: string;
  @Input() salonCurrency: string;
  @Input() bonusPoints: number;
  @Input() image: string;
  @Input() imageHeight = '200px';

  @Input() discountProducts: Product[];
  @Input() timestampToCalculateDiscount: Date;

  @Output() imageClicked = new EventEmitter<void>();
  @Output() bodyClicked = new EventEmitter<void>();

  public getDiscountPrice(product: Product): number {
    if (this.timestampToCalculateDiscount) {
      return BusinessObjectUtils.getPromotionalPrice(
        product,
        this.timestampToCalculateDiscount
      );
    } else {
      return BusinessObjectUtils.getAnyActivatePromotionalPrice(product);
    }
  }
}
